import { useRef } from 'react';
import { useSwipeToClose } from '../hooks/useSwipeToClose';
import type { SortMode, StatusFilter, UiPrefs } from '../lib/storage';

const STATUS_OPTIONS: Array<{ value: StatusFilter; label: string }> = [
  { value: 'all', label: '全部' },
  { value: 'live', label: '进行中' },
  { value: 'scheduled', label: '未开赛' },
  { value: 'finished', label: '已完赛' },
];
const ODDS_OPTIONS: Array<{ value: UiPrefs['oddsView']; label: string }> = [
  { value: 'compare', label: '对比' },
  { value: 'william', label: '威廉' },
  { value: 'ladbrokes', label: '立博' },
];
const SORT_OPTIONS: Array<{ value: SortMode; label: string }> = [
  { value: 'time', label: '按开赛时间' },
  { value: 'league', label: '按联赛' },
];

interface FilterSheetProps {
  open: boolean;
  prefs: UiPrefs;
  onChange: (patch: Partial<UiPrefs>) => void;
  onReset: () => void;
  onClose: () => void;
}

/** 底部筛选抽屉：状态 / 赔率视图 / 排序；支持下拉与遮罩关闭，选项行 ≥44px。 */
export function FilterSheet({ open, prefs, onChange, onReset, onClose }: FilterSheetProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const swipe = useSwipeToClose(onClose, { scrollRef, distance: 90, enabled: open });
  if (!open) return null;
  return <div className="sheet-backdrop filter-backdrop" onClick={onClose}>
    <section
      className={'sheet filter-sheet' + (swipe.closing ? ' closing' : '')}
      style={{ transform: swipe.offset > 0 ? 'translateY(' + swipe.offset + 'px)' : undefined }}
      role="dialog"
      aria-modal="true"
      aria-label="筛选"
      onClick={(event) => event.stopPropagation()}
      onTouchStart={swipe.onTouchStart}
      onTouchMove={swipe.onTouchMove}
      onTouchEnd={swipe.onTouchEnd}
    >
      <div className="sheet-handle" aria-hidden="true" />
      <header className="sheet-head">
        <h3>筛选与排序</h3>
        <button type="button" className="close-button" onClick={onClose}>关闭</button>
      </header>
      <div className="sheet-body" ref={scrollRef}>
        <div className="option-group">
          <span className="option-label">比赛状态</span>
          <div className="option-row">
            {STATUS_OPTIONS.map((option) => <button key={option.value} type="button" className={'option' + (prefs.statusFilter === option.value ? ' active' : '')} onClick={() => onChange({ statusFilter: option.value })}>{option.label}</button>)}
          </div>
        </div>
        <div className="option-group">
          <span className="option-label">赔率视图</span>
          <div className="option-row">
            {ODDS_OPTIONS.map((option) => <button key={option.value} type="button" className={'option' + (prefs.oddsView === option.value ? ' active' : '')} onClick={() => onChange({ oddsView: option.value })}>{option.label}</button>)}
          </div>
        </div>
        <div className="option-group">
          <span className="option-label">排序方式</span>
          <div className="option-row">
            {SORT_OPTIONS.map((option) => <button key={option.value} type="button" className={'option' + (prefs.sortMode === option.value ? ' active' : '')} onClick={() => onChange({ sortMode: option.value })}>{option.label}</button>)}
          </div>
        </div>
        <div className="sheet-actions">
          <button type="button" className="ghost" onClick={onReset}>恢复默认</button>
          <button type="button" className="primary" onClick={onClose}>完成</button>
        </div>
      </div>
    </section>
  </div>;
}
